module.exports = __webpack_public_path__ + "static/img/jiantailogo.d74bef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiantailogo.jpg
// module id = jfFR
// module chunks = 31